import React, { FC } from 'react';

import {
  AccountID,
  Aliases,
  ARN,
  AvailabilityZone,
  CloudID,
  CreatedAt,
  Name,
  Owner,
  Region,
  State,
  UpdatedAt,
  VPCId,
} from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataField/MetaGridFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import { Tags } from './MetadataField/Tags';

type DataType = Record<string, any> | string;

interface Props {
  name?: DataType;
  availabilityZone?: DataType;
  createdAt?: DataType;
  updatedAt?: DataType;
  state?: DataType;
  arn?: DataType;
  vpc?: DataType;
  owner?: DataType;
  region?: DataType;
  aliases?: DataType;
  tags?: DataType;
  createdAtTime?: 'unix' | 'utc' | 'dayjs';
}

export const MetadataCommonFields: FC<Props> = props => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;

  const {
    name = insight,
    availabilityZone = resource,
    createdAt = resource,
    state = resource,
    arn = insight,
    vpc = resource,
    owner = insight,
    region = insight,
    updatedAt = 'None',
    createdAtTime = 'dayjs',
    aliases = 'None',
    tags = resource,
  } = props;

  return (
    <>
      {name !== 'None' && Name(name)}
      {AccountID(insight)}
      {aliases !== 'None' && Aliases(aliases)}
      {region !== 'None' && Region(region)}
      {availabilityZone !== 'None' && AvailabilityZone(availabilityZone)}
      {state !== 'None' && availabilityZone === 'None' && State(state)}
      {CloudID(insight)}
      {arn !== 'None' && ARN(arn)}

      {tags !== 'None' && Tags(resource)}
      {resource?.general?.resource_type !== 'VPC' &&
        vpc !== 'None' &&
        VPCId(vpc)}
      {state !== 'None' && availabilityZone !== 'None' && State(state)}
      {createdAt !== 'None' && CreatedAt(createdAt, createdAtTime)}
      {updatedAt !== 'None' && UpdatedAt(updatedAt)}
      {owner !== 'None' && Owner(owner)}
    </>
  );
};
